import { type ReactNode } from "react";

import { FilterContext, useFilterState } from "./FilterContextProvider.shared";

export const FilterContextProvider = ({ children }: { children: ReactNode }) => {
  const value = useFilterState();

  return <FilterContext.Provider value={value}>{children}</FilterContext.Provider>;
};
